module.exports = __webpack_public_path__ + "img/certificateExport.23afb5cd.svg";